<template>
    <div>
        <div class="profile-name mb-5" :class="editProfileName?'editing':''">
            <div v-if="!editProfileName">
                <span class="profile-name-string" v-text="value"/>
                <i class="edit-profile-icon" @click="toggleEditProfileName"/>
            </div>
            <div v-else>
                <div class="input-group">
                    <input ref="profileName" type="text" class="form-control" id="name"
                           @input="$emit('input', $event.target)"
                           :value="value">
                    <div class="input-group-append">
                        <button class="btn btn-success"
                                @click="toggleEditProfileName"
                                v-text="textOk"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['value', 'textOk'],
        data() {
            return {
                editProfileName: false
            }
        },
        methods: {
            toggleEditProfileName() {
                this.editProfileName = !this.editProfileName;
                if (this.editProfileName) {
                    this.$nextTick(() => {
                        this.$refs.profileName.focus()
                    });
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    @import '../styles/colors.scss';

    .profile-name {
        background: $greenGradient;
        text-align: center;
        color: #fff;
        font-weight: bold;
        margin: 0 -20px 0;
        padding: 10px;
        white-space: nowrap;

        &.editing {
            padding: 4px 10px;
        }

        input {
            margin-right: 1px;
            background: rgba(0, 0, 0, 0.2);
            color: #fff;
            border: none !important;
            text-align: center !important;
            font-weight: bold;
        }

        button {
            background: #22936B;
            border-color: #22936B;
        }
    }


    .profile-name-string {
        max-width: 70%;
        overflow: hidden;
        display: inline-block;
        text-overflow: ellipsis;
        height: 20px;
    }

    .edit-profile-icon {
        background: url("../assets/icons/edit-icon.svg") no-repeat;
        width: 24px;
        height: 18px;
        display: inline-block;
        margin-left: 15px;
        cursor: pointer;
    }
</style>
